import * as Mtds from '@mattilsynet/design/react'
import type { Sample } from '../../types/types'

export const SampleShippingAddress = ({
  address,
  showName = false
}: {
  address?: Pick<
    NonNullable<Sample['shippingAddress']>,
    | 'name'
    | 'addressLine1'
    | 'addressLine2'
    | 'postalCode'
    | 'city'
    | 'countryCode'
  > | null
  showName?: boolean
}) =>
  address ? (
    <Mtds.Grid data-gap='0'>
      {showName && address.name && (
        <Mtds.Muted>Mottaksadresse: {address.name}</Mtds.Muted>
      )}
      <Mtds.Muted>{address.addressLine1}</Mtds.Muted>
      {address.addressLine2 && <Mtds.Muted>{address.addressLine2}</Mtds.Muted>}
      <Mtds.Muted>
        {address.postalCode} {address.city}
      </Mtds.Muted>
      <Mtds.Muted>{address.countryCode}</Mtds.Muted>
    </Mtds.Grid>
  ) : null
